import { Box, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { CalendarToday, HistoryToggleOff, Receipt, Calculate, ViewCompact, FilterAlt, CheckCircleOutlined } from "@mui/icons-material";
import DialogFiltroData from "./DialogFiltroData";
import DialogFiltroStatoOrdine from "./DialogFiltroStatoOrdine";
import DialogFiltroFatturati from "./DialogFiltroFatturati";
import DialogFiltroTotale from "./DialogFiltroTotale";
import { grey } from "@mui/material/colors";
import { getContrastRatio } from "@mui/material";
import { useTheme } from "@emotion/react";
import DialogFiltroTipi from "./DialogFiltroTipi";
import DialogCampiRicerca from "./DialogCampiRicerca";
import { ottieniFiltriAttivi } from "./FiltriAttivi";
import BSSMenu from "../../../form/BSSMenu";
const {logger} = useBSSLogger();

const MenuFiltri = ({menuFiltri, setMenuFiltri, filtri, setFiltri, stati, tipispedizione, campiRicerca}) => {

    const theme = useTheme();
    const [calendario, setCalendario] = useState({mostra: false, da: null, a: null})
    const [dialogFiltriStati, setDialogFiltriStati] = useState({mostra: false});
    const [dialogFiltroFatturati, setDialogFiltroFatturati] = useState({mostra: false});
    const [dialogFiltroTotale, setDialogFiltroTotale] = useState({mostra: false});
    const [dialogFiltroTipi, setDialogFiltroTipi] = useState({mostra: false});
    const [dialogCampiRicerca, setDialogCampiRicerca] = useState({mostra: false});
    const chiudiMenu = () => setMenuFiltri({open: false, anchorEl: null});
    const filtriAttivi = ottieniFiltriAttivi(filtri)

    const MenuProps = {
        anchorEl: menuFiltri.anchorEl,
        open: menuFiltri.open,                 
        onClose: e => {chiudiMenu()},        
        sx:{
            height: 250,
            '& .MuiMenuItem-root': {
                cursor: "pointer",
                fontSize: 12,
                '&:nth-of-type(even)': {                            
                    backgroundColor: BSSComps_spedizioniweb2_theme.palette.mode === 'light' ? grey[200]: grey[800]
                },       
                '&:hover': {
                    backgroundColor: 'primary.main',
                    color: getContrastRatio("#fff", theme.palette.primary.main) >= getContrastRatio("#000", theme.palette.primary.main) ? "#fff" : "#000",
                    '& *': {
                        color: `${getContrastRatio("#fff", theme.palette.primary.main) >= getContrastRatio("#000", theme.palette.primary.main) ? "#fff" : "#000"}`,
                    }
                }
            }
        }
    }

    return (
        <>
            <BSSMenu 
                {...{MenuProps}}
                rightAlignment={false}
            >
                <MenuItem dense onClick={e => {
                    setCalendario({mostra: true});
                    chiudiMenu();
                }} >
                    <ListItemIcon>
                        <CalendarToday color="primary" sx={{cursor: "pointer"}} />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("rangedidate")}
                    </ListItemText>

                    {(filtriAttivi.dadata || filtriAttivi.adata) && (
                        <CheckCircleOutlined color="success" />
                    )}
                </MenuItem>
                <MenuItem dense onClick={e => {
                    setDialogFiltriStati({mostra: true});
                    chiudiMenu();
                }}>
                    <ListItemIcon>
                        <HistoryToggleOff color="primary" sx={{cursor: "pointer"}}  />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("mostrasoloinstato")}
                    </ListItemText>
                    {filtriAttivi.statiSelezionati && (
                        <CheckCircleOutlined color="success" />
                    )}
                </MenuItem>
                <MenuItem dense onClick={e => {
                    setDialogFiltroFatturati({mostra: true});
                    chiudiMenu();
                }}>
                    <ListItemIcon>
                        <Receipt color="primary" sx={{cursor: "pointer"}}  />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("mostrainbaseafattura")}
                    </ListItemText>
                    {filtriAttivi.fatturato && (
                        <CheckCircleOutlined color="success" />
                    )}
                </MenuItem>
                <MenuItem dense onClick={e => {
                    setDialogFiltroTotale({mostra: true});
                    chiudiMenu();
                }}>
                    <ListItemIcon>
                        <Calculate color="primary" sx={{cursor: "pointer"}}  />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("filtrapertotale")}         
                    </ListItemText>
                    {filtriAttivi.totaleordine && (
                        <CheckCircleOutlined color="success" />
                    )}
                </MenuItem>
                <MenuItem dense onClick={e => {
                    setDialogFiltroTipi({mostra: true});
                    chiudiMenu();
                }}>
                    <ListItemIcon>
                        <ViewCompact color="primary" sx={{cursor: "pointer"}}  />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("filtrapertipo")}       
                    </ListItemText>
                    {filtriAttivi.tipiSelezionati && (
                        <CheckCircleOutlined color="success" />
                    )}  
                </MenuItem>
                <MenuItem dense onClick={e => {
                    setDialogCampiRicerca({mostra: true});
                    chiudiMenu();
                }}>
                    <ListItemIcon>
                        <FilterAlt color="primary" sx={{cursor: "pointer"}}  />
                    </ListItemIcon>
                    <ListItemText>
                        {__t("filtrasucampi")}         
                    </ListItemText>
                    {filtriAttivi.campiRicercaSelezionati && (
                        <CheckCircleOutlined color="success" />
                    )} 
                </MenuItem>
            </BSSMenu>


            <DialogFiltroData filtri={filtri} setFiltri={setFiltri} calendario={calendario} setCalendario={setCalendario} />
            <DialogFiltroStatoOrdine stati={stati} filtri={filtri} setFiltri={setFiltri} dialogFiltriStati={dialogFiltriStati} setDialogFiltriStati={setDialogFiltriStati} />
            <DialogFiltroFatturati filtri={filtri} setFiltri={setFiltri} dialogFiltroFatturati={dialogFiltroFatturati} setDialogFiltroFatturati={setDialogFiltroFatturati} />
            <DialogFiltroTotale filtri={filtri} setFiltri={setFiltri} dialogFiltroTotale={dialogFiltroTotale} setDialogFiltroTotale={setDialogFiltroTotale} />
            <DialogFiltroTipi tipispedizione={tipispedizione} filtri={filtri} setFiltri={setFiltri} dialogFiltroTipi={dialogFiltroTipi} setDialogFiltroTipi={setDialogFiltroTipi} />
            <DialogCampiRicerca campiRicerca={campiRicerca} filtri={filtri} setFiltri={setFiltri} dialogCampiRicerca={dialogCampiRicerca} setDialogCampiRicerca={setDialogCampiRicerca} />
        </>
    )
}

export default MenuFiltri